import {compressFile} from '@hconnect/common/files/compressFile'

import {
  JobsToBeDoneInsightCreateDto,
  JobsToBeDoneInsightFormValues,
  JobsToBeDoneInsightUpdateDto
} from '../types'

export const mapJobsToBeDoneInsightFormValuesToCreateDto = (
  formValues: JobsToBeDoneInsightFormValues
): JobsToBeDoneInsightCreateDto => {
  return {
    plantUpmId: formValues.plantUpmId,
    jobToBeDoneId: formValues.jobToBeDoneId,
    activityId: formValues.activityId,
    activityTaskId: formValues.activityTaskId,
    timeSpent: formValues.timeSpent,
    description: formValues.description,
    files: formValues.attachments
  }
}

export const prepareJobsToBeDoneInsightFormData = async (
  data: JobsToBeDoneInsightCreateDto
): Promise<FormData> => {
  const formData = new FormData()

  if (data.timeSpent) {
    formData.append('timeSpent', data.timeSpent)
  }

  if (data.description) {
    formData.append('description', data.description)
  }

  if (data.files && data.files.length > 0) {
    await attachmentFilesToFormData(data.files, formData)
  }

  return formData
}

export const attachmentFilesToFormData = async (value: readonly File[], formData: FormData) => {
  const attachmentFiles: File[] = await Promise.all(
    value.filter(Boolean).map((file: File) => compressFile(file))
  )
  attachmentFiles.forEach((file) => {
    formData.append('attachments', file, file.name)
  })
}

export const prepareJobsToBeDoneInsightUpdateFormData = async (
  data: JobsToBeDoneInsightUpdateDto
): Promise<FormData> => {
  const formData = new FormData()

  if (data.timeSpent) {
    formData.append('TimeSpent', data.timeSpent)
  }

  formData.append('Description', data.description)

  if (data.newAttachments && data.newAttachments.length > 0) {
    const compressedFiles = await Promise.all(
      data.newAttachments.filter(Boolean).map((file: File) => compressFile(file))
    )
    compressedFiles.forEach((file) => {
      formData.append('NewAttachments', file, file.name)
    })
  }

  if (data.attachmentIdsToRemove && data.attachmentIdsToRemove.length > 0) {
    data.attachmentIdsToRemove.forEach((id) => {
      formData.append('AttachmentIdsToRemove', id)
    })
  }

  return formData
}
